import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", { d: "M11.448 16.449L7.551 12.55C8.998 8.167 13.13 5 18 5c.323 0 .643.014.959.041.027.316.041.636.041.96 0 4.87-3.165 9-7.552 10.448z" }),
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M8 16l-1 1M9.5 17.5l-1 1M6.5 14.5l-1 1"
    }),
    _createVNode("circle", {
      cx: "13",
      cy: "11",
      r: "1"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M14 6l4 4"
    }),
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M14 15.5V19l-9-9h3.5"
    })
  ]))
}